const TEXT = {
    Chat: {
        en: 'Chat',
        ar: 'المحادثات'
    },
    SearchUsers: {
        en: 'Search users...',
        ar: 'ابحث عن مستخدمين...'
    },
    NewChat: {
        en: 'New Chat',
        ar: 'محادثة جديدة'
    },
    GroupChat: {
        en: 'Group Chat',
        ar: 'محادثة جماعية'
    },
    TypeMessage: {
        en: 'Type a message...',
        ar: 'اكتب رسالة...'
    },
    Send: {
        en: 'Send',
        ar: 'إرسال'
    },
    NoMessages: {
        en: 'No messages yet. Start the conversation!',
        ar: 'لا توجد رسائل بعد. ابدأ المحادثة!'
    },
    SelectChat: {
        en: 'Select a chat to start messaging',
        ar: 'اختر محادثة لبدء المراسلة'
    },
    CreateGroup: {
        en: 'Create Group',
        ar: 'إنشاء مجموعة'
    },
    GroupName: {
        en: 'Group Name',
        ar: 'اسم المجموعة'
    },
    SelectMembers: {
        en: 'Select Members',
        ar: 'اختر الأعضاء'
    },
    Create: {
        en: 'Create',
        ar: 'إنشاء'
    },
    Cancel: {
        en: 'Cancel',
        ar: 'إلغاء'
    },
    Typing: {
        en: 'typing...',
        ar: 'يكتب...'
    },
    Today: {
        en: 'Today',
        ar: 'اليوم'
    },
    Yesterday: {
        en: 'Yesterday',
        ar: 'أمس'
    }
};

export default TEXT;
